module.exports = "<abc-carousel-card-deck></abc-carousel-card-deck>\n"